import { render, staticRenderFns } from "./TweetDetailsDialog.vue?vue&type=template&id=2a22d4bc"
import script from "./TweetDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./TweetDetailsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports